import React, { useState } from "react";
import { FormGroup, ControlLabel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactPasswordStrength from "react-password-strength";

export type PasswordData = { score: number, password: string };

export const validatePassword = (passwordData?: PasswordData) => passwordData
    && passwordData.password.length >= 8;

export const CenterContainer = ({ children }: { children: JSX.Element[] | JSX.Element }) => {
    return (
        <div className="rg-center-container">
            <div className="rg-center-content">
                { children }
            </div>
        </div>
    );
};

type PasswordFormProps = {
    passwordData?: PasswordData,
    setPasswordData: (passwordData: PasswordData) => void
};

export const PasswordForm = ({ passwordData, setPasswordData }: PasswordFormProps) => {
    const [showPassword, setShowPassword] = useState(false);

    const displayPasswordScore = (score: number) => {
        const [displayText, displayColor] = validatePassword(passwordData) ? [
            ["weak", "#d1462f"],
            ["fair", "#d1462f"],
            ["medium", "#57b8ff"],
            ["good", "#57b8ff"],
            ["strong", "#2fbf71"]
            ][score]
        : ["too short", "#d1462f"];
        return (
            <span style={{color: displayColor}}>{ displayText }</span>
        );
    };

    return (
        <FormGroup>
            <ControlLabel>Password</ControlLabel>
            <div className="rg-password-box">
                <ReactPasswordStrength
                    minScore={0}
                    inputProps={{
                        name: "password_input",
                        autoComplete: "off",
                        type: showPassword ? "text" : "password"
                    }}
                    changeCallback={ setPasswordData }
                />
                <span className="rg-visibility-toggle" onClick={ () => setShowPassword(val => !val) } >
                    <FontAwesomeIcon
                        icon={ showPassword ? "eye" : "eye-slash" }
                        style={{color: showPassword ? "lightgray" : "darkgray"}}
                    />
                </span>
            </div>
        <div className="rg-password-desc">
            Password strength: {
                passwordData
                    && displayPasswordScore(passwordData.score)
            }
            <ul className="fa-ul">
                <li><FontAwesomeIcon icon={"circle"} listItem />Password must contain at least 8 characters.</li>
                <li><FontAwesomeIcon icon={"circle"} listItem />Strong passwords use a mixture of letters, numbers, and symbols.</li>
                <li><FontAwesomeIcon icon={"circle"} listItem />Avoid using common words, phrases, or personal information.</li>
                <li><FontAwesomeIcon icon={"circle"} listItem />Avoid reusing any passwords that have been used elsewhere.</li>
            </ul>
        </div>
        </FormGroup>
    );
}
